import { QueryData } from "@supabase/supabase-js";
import { queryOptions } from "@tanstack/react-query";
import { IterableElement } from "type-fest";

import { supabase } from "@/lib/supabase";

export type NCRJob = IterableElement<QueryData<typeof ncrJobsQuery>>;

const ncrJobsQuery = supabase
  .from("Job")
  .select("*, customer:Customer(id,name,billing), customFieldValues:JobCustomFieldValue(*)")
  .eq("deleted", false)
  .like("number", "NCR-____")
  .order("number", { ascending: false })
  .throwOnError();

export const ncrJobsQueryOptions = queryOptions({
  queryKey: ["Job", "ncr"],
  queryFn: async () => (await ncrJobsQuery).data,
});
